"use client";
import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const StockPriceChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current && data?.length > 0) {
      const options = {
        series: [
          {
            name: "",
            data: data,
          },
        ],
        colors: ["#47B971"],
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
        },
        stroke: {
          curve: "straight",
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          // text: "Stock Price Movement",
          align: "left",
        },
        stroke: {
          width: 2,
          colors: ["#47B971"],
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            // inverseColors: false,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return (val / 10).toFixed(0);
            },
          },
          title: {
            // text: "Price",
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            format: " hh:mm:ss TT ", // Format for 12-hour time with AM/PM
          },
          tickAmount: "data", // This ensures labels are generated at the interval of the data points
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss TT",
          },
          y: {
            formatter: function (val) {
              return val.toFixed(2); // Adjust formatting as needed
            },
          },
        },
        toolbar: {
          tools: {
            download: false, // Hide the download button
            selection: false, // Hide the selection tool
            zoom: false, // Hide zoom control buttons
            zoomin: false, // Hide zoom in button
            zoomout: false, // Hide zoom out button
            pan: false, // Hide pan button
            reset: false, // Hide reset button
          },
        },
      };

      const chart = new ApexCharts(chartRef.current, options);
      chart?.render();

      return () => {
        chart.destroy();
      };
    }
  }, [data]);

  return <div id="chart" ref={chartRef}></div>;
};

export default StockPriceChart;
